import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { estimateHeadersService } from '../services/estimateHeaders.service';
import type { EstimateListFilters } from '../types/estimate.types';

export function useEstimates(companyId: string) {
  const [filters, setFilters] = useState<EstimateListFilters>({ search: '', status: 'all' });

  const query = useQuery({
    queryKey: ['estimates', companyId, filters],
    queryFn: () => estimateHeadersService.getList(companyId, filters),
    enabled: !!companyId,
  });

  return useMemo(() => ({
    items: query.data?.items || [],
    stats: query.data?.stats,
    isLoading: query.isLoading,
    error: query.error as Error | null,
    filters,
    setFilters,
    refetch: query.refetch,
  }), [query.data, query.error, query.isLoading, query.refetch, filters]);
}
